import { Footer } from "../components/Footer"
import { PayoutRTPMethods } from "../components/payout/PayoutRTPMethods"


export const PayoutRTPPage = () => {
    return (
        <div className="container">
            <PayoutRTPMethods />
            <Footer />
        </div>
    );
}